import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`  
  body {
    margin: 0;
    padding: 0;
    font-family: 'Noto Sans', serif;
    background: ${({ PRIMARY_BG_COLOR }) =>
        PRIMARY_BG_COLOR};
    color: ${({ PRIMARY_FONT_COLOR }) =>
        PRIMARY_FONT_COLOR};
    transition: all 0.4s;
    -ms-overflow-style: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    backface-visibility: hidden;
    
    > div:nth-child(6) {
      display: flex;
      align-items: center;
      justify-content: center;
       
      > div {
        outline: none;
      }
    }
  }

  * {
      outline: none;
      -webkit-tap-highlight-color: transparent;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      scrollbar-width: none;
  }

  *::-webkit-scrollbar {
      width: 0;
      height: 0;
  }
`;
